import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, createTheme, CssBaseline, Box } from '@mui/material';
import Header from './components/Header';
import About from './components/About';
import Services from './components/Services';
import Product from './components/Product';
import Contact from './components/Contact';
import GDPRPolicy from './components/GDPRPolicy';
import Trader from './components/Trader';

const theme = createTheme({
  palette: {
    primary: {
      main: '#14325c',
    },
    secondary: {
      main: '#20c6b7',
    },
    text: {
      primary: '#10233f',
      secondary: '#54657d',
    },
    background: {
      default: '#f3f7fb',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Montserrat", "Segoe UI", "Helvetica", "Arial", sans-serif',
    fontWeightRegular: 400,
    fontWeightBold: 700,
    h1: {
      fontWeight: 800,
      lineHeight: 1.05,
    },
    h2: {
      fontWeight: 800,
      lineHeight: 1.1,
    },
    h3: {
      fontWeight: 700,
      lineHeight: 1.15,
    },
    body1: {
      lineHeight: 1.7,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          colorScheme: 'light',
        },
        html: {
          scrollBehavior: 'smooth',
        },
        body: {
          minHeight: '100vh',
          background:
            'radial-gradient(circle at top, rgba(32, 198, 183, 0.18), transparent 30%), linear-gradient(180deg, #f5f8fc 0%, #eef3f8 100%)',
        },
        '#root': {
          minHeight: '100vh',
        },
        a: {
          color: 'inherit',
        },
      },
    },
    MuiContainer: {
      styleOverrides: {
        root: {
          paddingLeft: '20px',
          paddingRight: '20px',
          '@media (min-width:600px)': {
            paddingLeft: '28px',
            paddingRight: '28px',
          },
        },
      },
    },
    MuiButton: {
      defaultProps: {
        disableElevation: true,
      },
      styleOverrides: {
        root: {
          borderRadius: 999,
          textTransform: 'none',
          fontWeight: 700,
          paddingInline: 20,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 24,
        },
      },
    },
  },
});

const App = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <Box component="main" sx={{ flexGrow: 1 }}>
            <Routes>
              <Route
                path="/"
                element={
                  <>
                    <About />
                    <Services />
                    <Product />
                    <Contact />
                  </>
                }
              />
              <Route path="/policy" element={<GDPRPolicy />} />
              <Route path="/trader" element={<Trader />} />
            </Routes>
          </Box>
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default App;
